import React from "react";
import { useTranslation } from "react-i18next";
import { PageTitle } from "../../SharedComponents/PageTitle/PageTitle";
import "./AdminPageHeader.css";

export const AdminPageHeader = ({ title }) => {
  const { t } = useTranslation();
  return (
    <div className="AdminPageHeader">
      <PageTitle title={t(title)} />
    </div>
  );
};
